module.exports = __webpack_public_path__ + "static/media/burger-soda.a6112ee4.svg";